import {Component, ViewEncapsulation, OnInit, OnDestroy} from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';
import { AppService } from '@irb/app.service';
import { IrbAppEvents, IrbModelsEvents } from '@irb-common/events';
import { SecurityMasterService } from '../security-master/security-master.service';
import { IAlertDialogData } from '@irb/app.model';
import { UtilityService } from '@irb-common/services/utility.service';
import { IrbEditorsService } from '../../irb-editors/irb-editors.service'//IREBAL-26684

@Component({ standalone: false,
  selector: 'irb-import-equivalent-dialog',
  templateUrl: './import-equivalent-dialog.component.html',
  styleUrls: ['./import-equivalent-dialog.component.scss', '../../irb-common/styles/dialog.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ImportEquivalentDialogComponent implements OnInit, OnDestroy {
  file: any;
  hasFile: boolean = false;
  isValidFile: boolean = false;
  invalidFileErrorHeader: string;
  invalidFileErrorMessage: string;
  errorMessage: string;
  updateStatusCount = 0;
  progressTimer: any = null;
  isUiTest = false;

  constructor(
      public dialogRef: MatDialogRef<ImportEquivalentDialogComponent>,
      public as: AppService,
      public securityMasterService: SecurityMasterService,
      private util: UtilityService,
      public irbEditorsService: IrbEditorsService //IREBAL-26684
  ) {
  }

  ngOnInit() {
  }

  close() {
    this.dialogRef.close();
  }

  onFileChange(event: any) {
    this.file = event.target.files[0];
    this.hasFile = this.isValidFile = true;
    if (!this.file.name.endsWith('.csv')) {
      this.isValidFile = false;
      this.invalidFileErrorHeader = "Invalid file format.";
      this.invalidFileErrorMessage = "Extension type must be \".csv\"";
    }
    if (this.as.maxFileUploadSizeExceeded(this.file)) {
      this.triggerMaxFileUploadSizeExceededError();
    }
    this.errorMessage = "";
  }

  private triggerMaxFileUploadSizeExceededError() {
    this.isValidFile = false;
    this.invalidFileErrorHeader = "Invalid file size.";
    this.invalidFileErrorMessage = "Import files must contain fewer than 500 records, please reduce the number of records in your file.";
  }

  submitFile() {
    const f = new FormData();
    f.append('ImportSecurityEquivalents0', this.file, this.file.name);

    this.as.fireEvent(IrbAppEvents.SHOW_WAIT);
    this.securityMasterService.importSecurityEquivalentsAsync(f).subscribe((response: any) => {
      this.updateStatusCount = 0;
      if (this.progressTimer) clearTimeout(this.progressTimer);
      if (response.responseUtilityMap)
        this.actionStatusCheckIntervalStart(response.responseUtilityMap.statusId, 'IMPORT_UPDATE_EQUIVALENTS');
    }, () => {
      this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
    });
  }

  proceedWithSubmitResponse(res: any) {

    const response: any = JSON.parse(res.substring(res.indexOf('<textarea>') + 10, res.indexOf('</textarea>')));

    if (response.status && response.status === "fail") {
      if (response.message) {
        this.errorMessage = response.message;
      } else {
        this.isValidFile = false;
      }
      return;
    }
    if (response.message === "Invalid file format"){
      this.errorMessage ="Use our .csv template to prepare your file.";
      return;
    }

    response.unRecognized = response.unRecognized || {};
    response.NonInventoried = response.NonInventoried || {};
    const invalidRecords = (response.invalidRecords && response.invalidRecords.length > 0);
    const validRecords = (response.validRecords && response.validRecords.length > 0);
    const nonInventoried = (response.NonInventoried.data && response.NonInventoried.data.length > 0);
    const unRecognized = (response.unRecognized.data && response.unRecognized.data.length > 0);
    const unRecogCustCategory = (response.invalidCustomCategories && response.invalidCustomCategories.length > 0);

      response.isImportEquivalents = true;
      let savingParams: Array<any> = [];
      let inValidSymbolCnt = 0;
      if (response.unRecognized.data && response.unRecognized.data.length > 0) {
        for (const unRecognizedData of response.unRecognized.data) {
          if (this.checkIfValidCustomSymbol(unRecognizedData.securitySymbol)) {
            savingParams.push(unRecognizedData);
          } else {
            inValidSymbolCnt++;
          }
        }

        if (inValidSymbolCnt === response.unRecognized.data.length && !validRecords && !nonInventoried && !unRecogCustCategory) {
          this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
            severity: 'warn',
            summary: "Import Equivalents",
            detail: " Invalid custom symbol(s) entered."
          });

          this.close();
          return;
        }
      }
      response.unRecognized.data = savingParams;
      response.inValidSymbolCnt = inValidSymbolCnt;

      if (unRecogCustCategory) {
        this.as.fireEvent(IrbAppEvents.SHOW_CONFIRMATION, {
          dTitle: " Undefined Asset Categories ",
          msg: " Asset categories referenced in an imported security file must pre-exist as a menu choice in iRebal's settings, under securities.",
          dCancelBtnLabel: "Cancel",
          dProceedBtnLabel: "Continue",
          onCancel: (() => {
          }).bind(this),
          onProceed: (() => {
            this.unRecogCustCategoryProceed(invalidRecords, response, nonInventoried, unRecognized, validRecords);
          }).bind(this)
        } as IAlertDialogData);
      } else if (nonInventoried || unRecognized) {
        response.isAddToIrebal = true;
        this.as.fireEvent(IrbModelsEvents.SHOW_IMPORT_SECURITY_CATEGORY_SECURITIES, response);
      } else if (invalidRecords) {
        this.as.fireEvent(IrbModelsEvents.SHOW_IMPORT_EQUIVALENTS_ERROR, response);
      } else if (validRecords && !invalidRecords) {
        //IREBAL-26684
        this.securityMasterService.updateEquivalentsAsync(response.validRecords).subscribe((data: any) => {
          if (this.progressTimer) clearTimeout(this.progressTimer);
          if (data.responseStatus === "SUCCESS" && data.responseUtilityMap) {
            this.as.fireEvent(IrbAppEvents.SHOW_WAIT);
            this.updateEquivalentsStatusCheckIntervalStart(data.responseUtilityMap.statusId, 'INSERT_UPDATE_EQUIVALENTS');
          } else {
            this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
              severity: 'error',
              summary: 'Import Equivalents',
              detail: " An error occurred processing your request."
            });
          }
        });
      }
      this.close();
  }

  //IREBAL-26884
  updateEquivalentsStatusCheckIntervalStart(statusId: any,type: string) {
    this.irbEditorsService.actionStatusCheck(statusId).subscribe((statusResponse: any) => {
      const response = statusResponse?.responseData;
      const reqStatus = response?.reqStatus?.trim().toUpperCase();

      if (reqStatus === 'FAILED') {
        this.actionStatusCheckFailed();
      }

      if (reqStatus === 'STARTED' || reqStatus === 'NEW' || reqStatus === 'IN_PROGRESS') {
        this.updateProgressBarStatus(statusId,type);
      }

      if (reqStatus === 'COMPLETED') {
          this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
          severity: 'success',
          summary: 'Import Equivalents',
          detail: statusResponse.responseData.successRecCount + " security(ies) imported/updated. "
        });
        this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
        if (this.progressTimer) clearTimeout(this.progressTimer);
        this.close();
      }
    }, () => {
      this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
      if (this.progressTimer) clearTimeout(this.progressTimer);
    });
  }

  unRecogCustCategoryProceed(invalidRecords: any,response: any, nonInventoried: any,unRecognized: any,validRecords: any) {
    if(invalidRecords){
      this.as.fireEvent(IrbModelsEvents.SHOW_IMPORT_EQUIVALENTS_ERROR, response);
      this.close();
    } else if(nonInventoried ||unRecognized ){
      response.isAddToIrebal = true;
      this.as.fireEvent(IrbModelsEvents.SHOW_IMPORT_SECURITY_CATEGORY_SECURITIES, response);
      this.close();
    } else if(validRecords && !invalidRecords){
      //IREBAL-26684
      this.securityMasterService.updateEquivalentsAsync(response.validRecords).subscribe((data: any) => {
        if (this.progressTimer) clearTimeout(this.progressTimer);
        if (data.responseStatus === "SUCCESS" && data.responseUtilityMap) {
          this.as.fireEvent(IrbAppEvents.SHOW_WAIT);
          this.updateEquivalentsStatusCheckIntervalStart(data.responseUtilityMap.statusId, 'INSERT_UPDATE_EQUIVALENTS');
        } else{
          this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
            severity: 'error',
            summary: 'Import Equivalents',
            detail: " An error occurred processing your request."
          });
          this.close();
        }
      });
    }
    
  }

  checkIfValidCustomSymbol(unRecognizedSymbol: any) {
    let notAllowedSpCharSymbol ;
    let allowedSpCharSymbol ;
    let notAllowedSpCharPattern = /[^~!./#a-zA-Z0-9]/g;
    let allowedSpCharPattern = /[~!./#]/g;
    if (unRecognizedSymbol.match(notAllowedSpCharPattern) && unRecognizedSymbol.match(notAllowedSpCharPattern) != null)
      notAllowedSpCharSymbol = unRecognizedSymbol.match(notAllowedSpCharPattern);
    if (unRecognizedSymbol.match(allowedSpCharPattern) && unRecognizedSymbol.match(allowedSpCharPattern) != null)
      allowedSpCharSymbol = unRecognizedSymbol.match(allowedSpCharPattern);
    if ((notAllowedSpCharSymbol && notAllowedSpCharSymbol.length > 0) || (allowedSpCharSymbol && allowedSpCharSymbol.length > 2))
      return false;
    else
      return true;
  }

  updateProgressBarStatus(statusId: any, type: string) {
    let timeout = (this.updateStatusCount > 10) ? 8000 : (this.updateStatusCount > 2) ? 3000 : 1500;
    if (this.isUiTest)
      timeout = 0;
    this.updateStatusCount++;
    this.progressTimer = setTimeout(() => {
      if (type === 'IMPORT_UPDATE_EQUIVALENTS') {
        this.actionStatusCheckIntervalStart(statusId, type);
      }
      if (type === 'INSERT_UPDATE_EQUIVALENTS') {
        this.updateEquivalentsStatusCheckIntervalStart(statusId, type);
      }
    }, timeout);
  }

  actionStatusCheckIntervalStart(statusId: any, type: string) {
    this.securityMasterService.actionStatusCheck(statusId).subscribe((statusResponse: any) => {
      if (statusResponse.responseStatus === "SUCCESS") {
        const responseData = statusResponse.responseData;
        let reqStatus = 'FAILED';
        if (statusResponse.responseUtilityMap && statusResponse.responseUtilityMap.requestStatus) {
          reqStatus = statusResponse.responseUtilityMap.requestStatus.trim().toUpperCase();
        }

        if (reqStatus === 'STARTED' || reqStatus === 'NEW' || reqStatus === 'IN_PROGRESS') {
          this.updateProgressBarStatus(statusId,type);
        }

        if (reqStatus === 'COMPLETED') {
          this.proceedWithSubmitResponse(responseData);
          if (this.progressTimer) clearTimeout(this.progressTimer);
          this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
        }

        if (reqStatus === 'FAILED') {
          this.actionStatusCheckFailed();
        }
      } else {
        this.actionStatusCheckFailed();
      }
    }, () => {
      this.close();
      this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
      if (this.progressTimer)clearTimeout(this.progressTimer);
    });
  }

  actionStatusCheckFailed() {
    this.close();
    this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
    if (this.progressTimer) clearTimeout(this.progressTimer);
    this.as.fireEvent(IrbAppEvents.SHOW_ALERT, {
      dType: 'ERROR',
      dTitle: '',
      dProceedBtnLabel: '',
      msg: 'An error occurred processing your request.',
      onProceed: () => {
      }
    } as IAlertDialogData);
  }


  ngOnDestroy() {
    if (this.progressTimer) clearTimeout(this.progressTimer);
  }
}
